import { Static, TSchema } from "@sinclair/typebox";
import { Value } from "@sinclair/typebox/value";
/**
 * Cannot use because TypeCompiler requires "unsafe-eval"
 */
// import { TypeCompiler } from "@sinclair/typebox/compiler";

export default class SchemaValidator<T extends TSchema = TSchema> {
	readonly schema;
	// readonly #validator;

	constructor(schema: T) {
		this.schema = schema;

		// this.#validator = TypeCompiler.Compile(this.schema);
	}

	validate = (obj: unknown): obj is Static<T> => {
		return Value.Check(this.schema, obj);
		// return this.#validator.Check.bind(this.#validator);
	};
}

export type TypeFromSchemaValidator<SV extends SchemaValidator<TSchema>> = Static<SV["schema"]>;
